import React, { lazy } from "react";
import { Route, Navigate } from "react-router";
import { all_routes } from "./all-routes";

const ServicesShow = lazy(() => import("../pages/services-show"));
const ServiceForm = lazy(
  () => import("../services/presentation/pages/service-form")
);
const Services = lazy(() => import("../services/presentation/pages/services"));
const Home = lazy(() => import("../home/home"));
const AboutUs = lazy(() => import("../pages/about-us"));
const ContactUs = lazy(
  () => import("../contact-us/presentation/pages/contact-us")
);
const VideoAnalysis = lazy(() => import("../video-analysis/presentation/pages/video-analysis-us"));
const Videos = lazy(() => import("../video-analysis/presentation/pages/videos"));
const OneToOneService = lazy(() => import("../pages/one-to-one-service"));
const Error404 = lazy(() => import("../pages/error-404"));
const TermsCondition = lazy(() => import("../pages/terms-condition"));
const PrivacyPolicy = lazy(() => import("../pages/privacy-policy"));

const OurTeams = lazy(() => import("../pages/our-teams"));
const Testimonials = lazy(() => import("../pages/testimonials"));
const TestimonialDetail = lazy(() => import("../pages/testimonial-detail"));
const Gallery = lazy(() => import("../pages/gallery"));
const Login = lazy(() => import("../auth/presentation/pages/login"));
const Dashboard = lazy(
  () => import("../dashboard/presentation/pages/dashboard")
);
const Contacts = lazy(
  () => import("../contact-us/presentation/pages/contacts")
);
const ServiceDetails = lazy(() => import("../pages/service-detail"));
const UpdateService = lazy(
  () => import("../services/presentation/pages/service-form")
);

const CreateTestimonial = lazy(
  () => import("../testimonial/presentation/pages/testimonial-form")
);
const UpdateTestimonial = lazy(
  () => import("../testimonial/presentation/pages/testimonial-form")
);
const Testimonial = lazy(
  () => import("../testimonial/presentation/pages/testimonials")
);

const DashboardGallery = lazy(
  () => import("../gallery/presentation/pages/gallery")
);
const CreateGallery = lazy(
  () => import("../gallery/presentation/pages/gallery-form")
);
const UpdateGallery = lazy(
  () => import("../gallery/presentation/pages/gallery-form")
);

const routes = all_routes;

const publicRoutes = [
  {
    path: routes.home,
    element: <Home />,
    route: Route,
  },
  {
    path: routes.aboutUs,
    element: <AboutUs />,
    route: Route,
  },
  {
    path: routes.contactUs,
    element: <ContactUs />,
    route: Route,
  },
  {
    path: routes.videoAnalysis,
    element: <VideoAnalysis />,
    route: Route,
  },
  // Redirect bare /video-analysis to a default slug (online-analysis)
  {
    path: routes.videoAnalysisDefault,
    element: <Navigate to={routes.videoAnalysis.replace(":slug","online-analysis")} replace />,
    route: Route,
  },
  // One-to-one service (static page using slug)
  {
    path: routes.oneToOneService,
    element: <OneToOneService />,
    route: Route,
  },
  {
    path: routes.oneToOneDefault,
    element: <Navigate to={routes.oneToOneService.replace(":slug","1-2-1-coaching-sessions")} replace />,
    route: Route,
  },
  {
    path: routes.serviceDetail,
    element: <ServiceDetails />,
    route: Route,
  },
  {
    path: routes.allServices,
    element: <ServicesShow />,
    route: Route,
  },
  {
    path: routes.termsCondition,
    element: <TermsCondition />,
    route: Route,
  },
  {
    path: routes.privacyPolicy,
    element: <PrivacyPolicy />,
    route: Route,
  },
  {
    path: routes.ourTeams,
    element: <OurTeams />,
    route: Route,
  },
  {
    path: routes.testimonials,
    element: <Testimonials />,
    route: Route,
  },
  {
    path: routes.testimonialDetail,
    element: <TestimonialDetail />,
    route: Route,
  },
  {
    path: routes.gallery,
    element: <Gallery />,
    route: Route,
  },
  {
    path: "*",
    name: "NotFound",
    element: <Error404 />,
    route: Route,
  },
];

const dashboardRoutes = [
  {
    path: routes.dashboard,
    element: <Dashboard />,
    route: Route,
  },
  {
    path: routes.dashboardVideos,
    element: <Videos />,
    route: Route,
  },
  {
    path: routes.contacts,
    element: <Contacts />,
    route: Route,
  },
  {
    path: routes.dashboardServices,
    element: <Services />,
    route: Route,
  },
  {
    path: routes.createService,
    element: <ServiceForm />,
    route: Route,
  },
  {
    path: routes.updateService,
    element: <UpdateService />,
    route: Route,
  },
  {
    path: routes.createService,
    element: <ServiceForm />,
    route: Route,
  },
  {
    path: routes.updateService,
    element: <UpdateService />,
    route: Route,
  },
  {
    path: routes.dashboardTestimonials,
    element: <Testimonial />,
    route: Route,
  },
  {
    path: routes.createTestimonial,
    element: <CreateTestimonial />,
    route: Route,
  },
  {
    path: routes.updateTestimonial,
    element: <UpdateTestimonial />,
    route: Route,
  },
  {
    path: routes.dashboardGallery,
    element: <DashboardGallery />,
    route: Route,
  },
  {
    path: routes.addGallery,
    element: <CreateGallery />,
    route: Route,
  },
  {
    path: routes.editGallery,
    element: <UpdateGallery />,
    route: Route,
  },
];

const withoutHeaderRoutes = [
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
];
export { publicRoutes, withoutHeaderRoutes, dashboardRoutes };
